module.exports = __webpack_public_path__ + "static/media/sports_31.ecbc9c31.jpg";